import { tz } from "@date-fns/tz";
import { startOfDay } from "date-fns";

/** Start of the day in the given timezone, as a plain Date (not a TZDate) so it serializes as a UTC ISO string. */
export const toStartOfDay = (date: Date, timeZone: string): Date =>
  new Date(startOfDay(date, { in: tz(timeZone) }).getTime());
